import Helmet from "react-helmet";
import { Portada } from "../components/molecules/Portada";
import { FormRequerimientos } from "../components/molecules/FormRequerimientos";
import "../css/Requerimientos.css";



export const Requerimientos = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Requerimientos - Supre</title>
        <meta name="description" content="Requerimientos Supre" />
      </Helmet>
      <Portada className="c-block-3" Name="Requerimientos" />
      <div className="c-block-4">
        <div className="g-container-rq c-block-4__container">
          <div className="c-block-4__col--moto">
            <div className="c-block-4__box importante-box-estilizado">
              <div style={{ textAlign: "center" }}>
                <h1 style={{ marginBottom: "25px", color: "#ffffff" }}>
                  ¡Importante!
                </h1>
                <p className="c-block-4__p">
                  Ahora puedes autogestionar los siguientes certificados de forma más rápida
                  y sencilla desde nuestro canal oficial de WhatsApp:
                </p>
                <p className="c-block-4__p estilos-lista">
                  <span className="lista-item">✅ Paz y Salvo</span>
                  <span className="lista-item">✅ Levantamiento de prenda</span>
                  <span className="lista-item">✅ Certificado de estado de cuenta</span>
                </p>
                <p className="c-block-4__p">
                  Haz clic aquí para iniciar tu solicitud por 👉 {" "}
                  <a
                    href="https://wa.me/+12342306843?text=Hola!"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <strong className="link-whatsapp">WhatsApp</strong> 
                  </a>
                </p>
                <p className="c-block-4__p">
                  Si tu requerimiento es diferente, por favor completa el
                  siguiente formulario de acuerdo con tu necesidad del crédito.
                  Un asesor se comunicará contigo en los próximos 7 días hábiles
                  para darte solución lo antes posible.
                </p>
              </div>
            </div>
          </div>
          <div className="c-block-4__col">
            <FormRequerimientos />
          </div>
        </div>
      </div>
    </>
  );
};